import {
  SearchHitDocument,
  searchResult,
} from '../../../api/types/sessionSearch.type';
import {Query} from './Query';

export interface SessionSearch {
  id: string;
  advancedSearchId?: number;
  searchResult?: searchResult;
  name: string;
  familyMemberDocuments: boolean;
  threadedEmailDocuments: boolean;
  nearDuplicateDocuments: boolean;
  regexOnWorkProductAttributes: boolean;
  isSelected: boolean;
  isSaved?: boolean;
  isPinned?: boolean;
  lastRuntime?: Date;
  searchIsInProgress?:boolean;
  searchNotificationId?:number;
  query?: Query[];
  ordinal?: number;
  color?: string;
  indexId?: number;
}

export interface IShoppingCartItem {
  id: string;
  sourceID?: number;
  color?: string;
  type: ResultType;
  count?: string;
  caption?: string;
  SearchHitDocuments?: SearchHitDocument[];
}

export enum ResultType {
  PureHit = 'PureHit',
  EmailThread = 'EmailThread',
  FamilyMember = 'FamilyMember',
  NearDupe = 'NearDupe',
  Conceptual = 'Conceptual',
}

export interface BulkActionContextItem {
  ID: number;
  IncludePureHits: boolean;
  IncludeEmailThread: boolean;
  IncludeNearDupe: boolean;
  IncludeFamily: boolean;
  IncludeConcept: boolean;
  SourceTypeCode: string;
}
